import { motion } from "framer-motion";

const Manifesto = ({ t }) => (
  <section id="manifesto" data-testid="manifesto-section" className="relative py-28 md:py-40 px-6 md:px-12">
    <div
      aria-hidden="true"
      className="absolute bottom-0 right-0 w-[600px] h-[500px] rounded-full bg-[#00F0FF] opacity-[0.06] blur-[160px]"
    />
    <div className="relative max-w-7xl mx-auto">
      <motion.div
        initial={{ opacity: 0, y: 40, filter: "blur(10px)" }}
        whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.8 }}
        className="mb-20 md:mb-32"
      >
        <p className="text-sm font-bold tracking-[0.25em] uppercase text-[#00F0FF] mb-5">
          {t.manifesto.overline}
        </p>
        <h2 className="font-display font-bold tracking-tight text-4xl md:text-5xl lg:text-6xl">
          {t.manifesto.title}
        </h2>
      </motion.div>

      <div className="flex flex-col gap-28 md:gap-36">
        {t.manifesto.chapters.map((chapter, i) => (
          <motion.div
            key={chapter.number}
            data-testid={`manifesto-chapter-${chapter.number}`}
            initial={{ opacity: 0, y: 40, filter: "blur(10px)" }}
            whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className={`relative flex flex-col md:flex-row md:items-start gap-6 md:gap-16 ${
              i % 2 === 1 ? "md:flex-row-reverse md:text-right" : ""
            }`}
          >
            <span
              aria-hidden="true"
              className="font-display font-black text-[26vw] md:text-[11rem] leading-none bg-gradient-to-b from-white/15 to-transparent bg-clip-text text-transparent select-none shrink-0"
            >
              {chapter.number}
            </span>
            <div className={`md:pt-10 max-w-xl ${i % 2 === 1 ? "md:ml-auto" : ""}`}>
              <h3 className="font-display font-semibold text-2xl md:text-3xl tracking-tight mb-5">
                {chapter.title}
              </h3>
              <p className="text-base md:text-lg leading-relaxed text-white/60">{chapter.text}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default Manifesto;
